<template>
  <mtc-form-item :label="getDynamicLabel(item)">
    <template v-if="item.view == 'Date' || item.view == 'date'">
      <template v-if="single_mode === item.mode">
        <j-date :placeholder="getDynamicPlaceholder(item)" v-model="queryParam[item.field]" />
      </template>
      <div v-else>
        <j-date :placeholder="$t('label.startDate')"
                v-model="queryParam[item.field+'_begin']"
                :style="getRangeItemStyle(item)" />
        <span class="group-query-strig">~</span>
        <j-date :placeholder="$t('label.endDate')"
                v-model="queryParam[item.field+'_end']"
                :style="getRangeItemStyle(item)" />
      </div>
    </template>
    <template v-else-if="item.view == 'Datetime' || item.view == 'datetime'">
      <template v-if="single_mode===item.mode">
        <j-date :placeholder="getDynamicPlaceholder(item)"
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                v-model="queryParam[item.field]" />
      </template>
      <div v-else>
        <div>
          <j-date :placeholder="$t('startDate.pleaseChooseStartTime')"
                  :show-time="true"
                  date-format="YYYY-MM-DD HH:mm:ss"
                  :style="getRangeItemStyle(item)"
                  v-model="queryParam[item.field+'_begin']" />
          <span class="group-query-strig">~</span>
          <j-date :placeholder="$t('endDate.pleaseChooseStartTime')"
                  :show-time="true"
                  date-format="YYYY-MM-DD HH:mm:ss"
                  :style="getRangeItemStyle(item)"
                  v-model="queryParam[item.field+'_end']" />
        </div>
      </div>
    </template>
    <template v-else-if=" item.view == 'list' || item.view == 'radio' ">
      <a-select :placeholder="getDynamicPlaceholder(item)"
                v-model="queryParam[item.field]"
                show-search
                :filter-option="filterOption"
                allowClear>
        <a-select-option v-for="(op,opIndex) in dictOptions[item.field]"
                         :key="opIndex"
                         :value="op.value">
          {{ op.text }}
        </a-select-option>
      </a-select>
    </template>
    <template v-else-if=" item.view == 'checkbox'">
      <j-select-multiple :placeholder="getDynamicPlaceholder(item)"
                         :options="dictOptions[item.field]"
                         v-model="queryParam[item.field]" />
    </template>
    <template v-else>
      <div v-if="group_mode === item.mode">
        <a-input :placeholder="$t(`dynamic.${item.language_key}`)"
                 v-model="queryParam[item.field+'_begin']"
                 :style="getRangeItemStyle(item)" />
        <span class="group-query-strig">~</span>
        <a-input :placeholder="$t(`dynamic.${item.language_key}`)"
                 v-model="queryParam[item.field+'_end']"
                 :style="getRangeItemStyle(item)" />
      </div>
      <template v-else>
        <a-input :placeholder="getDynamicPlaceholderInput(item)" v-model="queryParam[item.field]" />
      </template>
    </template>
  </mtc-form-item>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'

export default {
  name: 'OnlineQueryFormItem',
  mixins: [mixinDevice],
  props: {
    item: {
      type: Object,
      default: () => {
      },
      required: true
    },
    dictOptions: {
      type: Object,
      default: () => {
      },
      required: true
    },
    queryParam: {
      type: Object,
      default: () => {
      },
      required: true
    }
  },
  components: {},
  data() {
    return {
      single_mode: 'single',
      group_mode: 'group'
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[ 0 ].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    // 范围选择控件的style
    getRangeItemStyle(item) {
      let width = ''
      if (this.isMobile()) {
        width = '100% !important'
      } else {
        width = 'calc(50% - 10px) !important'
      }
      return {
        width: width,
        minWidth: width
      }
    },
    getDynamicLabel(item) {
      const label = this.$getLanguageEnable() ? `dynamic.${item.language_key}`: item.label
      return label;
    },
    getDynamicPlaceholder(item){
      const placeholder = this.$getLanguageEnable() ? this.$t('tip.pleaseSelect')+this.$t(`dynamic.${item.language_key}`): '请选择'+item.label
      return placeholder
    },
    getDynamicPlaceholderInput(item){
      const placeholder = this.$getLanguageEnable() ? this.$t('tip.pleaseInput')+this.$t(`dynamic.${item.language_key}`): '请输入'+item.label
      return placeholder
    }
  }
}
</script>

<style scoped>
/* 解决移动端下，范围选择上下排列的输入框不能顶开高度的问题 */
.j-jl-cgreport-query .ant-form-item-control {
  height: auto !important;
}
</style>